/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Button, Dialog, DialogBody } from "@material-tailwind/react";
import { IoClose } from "react-icons/io5";
import * as XLSX from "xlsx";
import { toast } from "react-toast";
import { Helmet } from "react-helmet";
import { AiFillPlusCircle } from "react-icons/ai";
import { FiTrash } from "react-icons/fi";
import { addSendMessage } from "../../../service/api";
import Input from "../../../components/input";
import { Link } from "react-router-dom";
import TextArea from "../../../components/textArea";
import SmsLogDataTableComponent from "../../../components/helper/sms-log-datatable";

const MarketingMessages = () => {
  // STATE VARIABLES
  const [addDialog, setAddDialog] = useState(false);
  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);
  console.log("%c Line:45 🧀 data", "color:#ffdd4d", data);
  const [addMarketingMessagesFormLoading] = useState(false);

  const [smsBody, setSmsBody] = useState(null);

  const [filePreview, setFilePreview] = useState(null);

  // HANDLE FILE UPLOAD
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFile(file);
  };

  // Remove file
  const handleFileRemove = () => {
    setFile(null);
    setFilePreview(null);
  };
  // HANDLE FILE SUBMISSION
  const handleFileSubmit = (e) => {
    e.preventDefault();
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryStr = event.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
        setData(sheetData);
        let sendData = [];
        sheetData?.forEach((el) => {
          sendData.push({
            firstName: el["First Name"],
            lastName: el["Last Name"],
            phoneNumber: el["Contact"],
          });
        });
        const jsonData = { [sheetName]: sheetData };
        console.log(JSON.stringify(sendData));
        addSendMessage({ data: JSON.stringify(sendData), body: smsBody })
          .then((res) => {
            if (res?.status) {
              toast.success(res?.message);
              // addProductFormik.resetForm();
            } else {
              console.log(res?.message);
              toast.error(res?.message);
            }
          })
          .catch((e) => {
            toast.error(e?.response?.data?.message);
          });
        toast.success("File uploaded and data processed successfully!");
        setAddDialog(false);
        setFile(false);
      };
      reader.readAsBinaryString(file);
    } else {
      toast.error("Please upload a file.");
    }
  };

  return (
    <section className="px-0 py-2 xl:p-10 lg:p-10 min-h-screen xl:min-h-full lg:min-h-full">
      {/* PAGE TITLE */}
      <Helmet>
        <title>Marketing Messages | Shapes Brow Bar</title>
      </Helmet>

      {/* HEADING */}
      <div className="block xl:flex lg:flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-proxima-bold text-black tracking-tight">
            Marketing Messages
          </h1>
          <h2 className="text-base xl:text-lg lg:text-lg font-proxima-regular text-greyText">
            Manage the Marketing Messages currently present on the website
          </h2>
        </div>

        <div className="flex items-center gap-4">
          {/* DATE RANGE PICKER */}
          {/* <div className="relative mt-2 xl:mt-0 lg:mt-0 w-full xl:w-auto lg:w-auto">
            <div
              ref={domNode}
              className="w-full xl:w-rangePicker lg:w-rangePicker flex items-center gap-3 border border-authBorder rounded-lg py-3 px-5 bg-white cursor-pointer"
            >
              <FaCalendar className="w-4 h-4 text-greyText" />
              <input
                type="text"
                name="dateRange"
                placeholder="Select the date range"
                value={startDate && endDate ? `${startDate} - ${endDate}` : ""}
                onClick={() => setDatepicker(!datepicker)}
                className="w-full bg-white outline-none font-proxima-semibold text-sm focus:outline-none active:outline-none placeholder:font-proxima-regular transition-all duration-300 ease-linear text-black"
              />

              <MdRefresh
                title="Refresh"
                onClick={clearDateFilters}
                className="w-5 h-5 text-greyText cursor-pointer transition-transform transform hover:scale-110"
              />
            </div>
            {datepicker && (
              <div
                ref={domNode}
                className="absolute top-12 right-0 transition-all duration-300 ease-linear z-50"
              >
                <DateRangePicker
                  ranges={[selectionRange]}
                  dragSelectionEnabled
                  showPreview
                  onChange={(e) => {
                    if (e.selection) {
                      setStartDate(
                        moment(e.selection.startDate).format("YYYY/MM/DD")
                      );
                      setEndDate(
                        moment(e.selection.endDate).format("YYYY/MM/DD")
                      );
                      setSelectionRange(e.selection);
                    }
                  }}
                  className="shadow-xl font-proxima-regular rounded-xl border border-authBorder cursor-pointer"
                />
              </div>
            )}
          </div> */}

          <Link
            to={
              "https://storage.googleapis.com/cdn-roundtechsquare/NewTest.ods"
            }
          >
            <p className="text-s font-proxima-bold text-black">Example Sheet</p>
          </Link>
          <div className="mt-2 xl:mt-0 lg:mt-0">
            {/* SEARCHBAR */}
            <div className="w-full xl:w-searchBar lg:w-searchBar">
              <Input
                type="text"
                placeholder="Message Body"
                name="smsBody"
                id="smsBody"
                value={smsBody}
                onChange={(e) => {
                  setSmsBody(e?.target?.value);
                }}
              />
            </div>
          </div>

          {/* UPLOAD FILE BUTTON */}
          <Button
            className="bg-logoYellow rounded-lg py-3 px-8 text-sm font-proxima-semibold shadow-none hover:shadow-none normal-case hover:bg-opacity-80 transition-all duration-300 ease-in-out w-50"
            onClick={() => setAddDialog(true)}
          >
            Upload File
          </Button>
        </div>
      </div>

      {/* INVENTORY TABLE */}
      <div className="mt-5">
        <SmsLogDataTableComponent />
      </div>

      {/* UPLOAD FILE DIALOG */}
      <Dialog
        open={addDialog}
        handler={() => setAddDialog(!addDialog)}
        size="xs"
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
        <DialogBody className="p-0">
          <form onSubmit={handleFileSubmit}>
            {/* HEADER */}

            <div className="bg-white rounded-lg border border-authBorder mt-3">
              <div className="px-5 py-3 border-b border-authBorder flex items-center justify-between">
                <div>
                  <h5 className="text-sm font-proxima-bold text-black">
                    Upload File
                  </h5>
                  <p className="text-xs font-proxima-regular text-greyText">
                    Attach the file you want to upload
                  </p>
                </div>
                <Button
                  className="p-2 rounded-full bg-white shadow-none hover:shadow-none hover:bg-black hover:bg-opacity-5"
                  onClick={() => setAddDialog(!addDialog)}
                >
                  <IoClose className="w-4 h-4 text-greyText" />
                </Button>
              </div>

              {/* FILE UPLOAD AREA */}
              <div className="p-5">
                <div className="flex justify-center items-center">
                  <div className="w-40 h-productImage rounded-md bg-[#F5F5F5] bg-opacity-50 border border-authBorder cursor-pointer hover:border-logoYellow transition-all duration-300 ease-in-out p-5 flex flex-col items-center justify-center">
                    <input
                      type="file"
                      accept=".xlsx,.xls,.ods,.csv"
                      onChange={handleFileUpload}
                      className="hidden"
                      id="file-upload"
                    />
                    <label
                      htmlFor="file-upload"
                      className="cursor-pointer flex flex-col items-center justify-center"
                    >
                      <AiFillPlusCircle className="w-8 h-8 text-greyText" />
                      <div className="mt-2 text-center">
                        <p className="text-xs font-proxima-semibold text-greyText">
                          Click here to upload a file
                        </p>
                        <p className="text-xs font-proxima-regular text-greyText mt-1">
                          (XLSX, XLS, ODS, CSV)
                        </p>
                      </div>
                    </label>
                  </div>
                </div>

                <div className="p-5 flex items-center justify-between relative">
                  {/* File Name */}
                  {file && (
                    <p className="text-lg font-proxima-semibold text-greyText">
                      Uploaded File: {file.name}
                    </p>
                  )}

                  {/* Remove Button */}
                  {file && (
                    <Button
                      className="p-2 rounded-full shadow-none hover:shadow-none bg-white border border-logoYellow"
                      onClick={handleFileRemove}
                    >
                      <FiTrash className="w-3 h-3 text-black" />
                    </Button>
                  )}
                </div>
              </div>

              <div className="my-2  mx-5">
                {/* SEARCHBAR */}
                <div className="w-full">
                  <TextArea
                    type="text"
                    placeholder="Message Body"
                    name="smsBody"
                    id="smsBody"
                    value={smsBody}
                    onChange={(e) => {
                      setSmsBody(e?.target?.value);
                    }}
                  />
                </div>
              </div>

              {/* SUBMIT BUTTON */}
              <div className="px-5 py-3 border-t border-authBorder flex items-center justify-end">
                <Button
                  className="bg-logoYellow rounded-lg py-3 px-8 text-sm font-proxima-semibold shadow-none hover:shadow-none normal-case hover:bg-opacity-80 transition-all duration-300 ease-in-out"
                  type="submit"
                  disabled={addMarketingMessagesFormLoading}
                >
                  {addMarketingMessagesFormLoading
                    ? "Uploading..."
                    : "Upload File"}
                </Button>
              </div>
            </div>
          </form>
        </DialogBody>
      </Dialog>
    </section>
  );
};

export default MarketingMessages;
